import { render, staticRenderFns } from "./ServiceCategoryListPage.vue?vue&type=template&id=bc142f68&"
import script from "./ServiceCategoryListPage.vue?vue&type=script&lang=js&"
export * from "./ServiceCategoryListPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports